module.exports = __webpack_public_path__ + "img/section1 - Copy - Copy - Copy.6f92e6e3.png";